<script setup lang="ts">
import { computed, useSlots } from "vue";
import { LuvProgressInline } from "@polargold/luv-ui-library";
import { useIsEmbeddedStore } from "@/stores/isEmbeddedStore";
import ContentLayoutSubHeader from "./partials/ContentLayoutSubHeader.vue";

const props = defineProps<{
    noContainer?: boolean;
    noPadding?: boolean;
    isLoading?: boolean;
}>();

const noContainer = computed(() => props.noContainer);
const isEmbeddedStore = useIsEmbeddedStore();
const slots = useSlots();

const hasSubHeaderContent = computed(() => !!slots.subHeader);
const hasCartButtonContent = computed(() => !!slots.cartButton);

const footerClassNames = computed(() => [
    "bg-luv-white",
    "w-full",
    "sticky",
    "bottom-0",
    "z-[900]",
    "shadow-2xl",
    "fixed",
    "footer-shadow",
    "h-[80px]",
]);
</script>

<template>
    <div>
        <div v-if="isLoading" class="flex justify-center">
            <LuvProgressInline/>
        </div>

        <div v-if="!isLoading">
            <ContentLayoutSubHeader
                :has-sub-header-content="hasSubHeaderContent"
                :has-cart-button-content="hasCartButtonContent"
            >
                <template #subHeader>
                    <slot name="subHeader"/>
                </template>

                <template #cartButton>
                    <slot name="cartButton"/>
                </template>
            </ContentLayoutSubHeader>

            <div
                v-if="!!$slots.navigation && !isEmbeddedStore.isEmbedded"
                class="py-module-md flex items-center"
            >
                <div class="w-full">
                    <slot name="navigation"/>
                </div>
            </div>

            <div
                :class="[
                    'bg-luv-lightgray',
                    'shrink',
                    'w-full',
                    {'py-module-md': !noPadding},
                    {'pb-100': !!$slots.footer}
                ]"
            >
                <div
                    :class="[{container: !noContainer && !isEmbeddedStore.isEmbedded }, 'mx-auto']"
                >
                    <slot/>
                </div>
            </div>


            <div
                :class="footerClassNames"
                v-if="!!$slots.footer && !isLoading"
            >
                <div
                    class="container mx-auto h-full flex items-center justify-end">
                    <slot name="footer"/>
                </div>
            </div>
        </div>
    </div>
</template>
